module.exports = __webpack_public_path__ + "static/media/cedis.272f1951.svg";